import React from 'react';
import loadable from '@loadable/component';

import query from './query.graphql';

const ChangelogContent = loadable(() =>
  import(
    /* webpackChunkName: "article" */ '../../editorial-content/editorial-content'
  )
);

const ChangelogContentPage = ({ data }) => (
  <ChangelogContent data={data.prismicArticle} />
);

ChangelogContentPage.graphQL = query;

ChangelogContentPage.variables = vars => {
  // Prismic preview feature sends this parameter
  // then we send that along to the Prismic API integration
  // as the `ref` option. This lets us preview unpublished
  // articles.
  if (vars.token) {
    return {
      id: vars.documentId,
      ref: vars.token,
    };
  }

  return vars;
};

export default ChangelogContentPage;
